import React, { useEffect, useState } from "react";
import { Route } from "react-router-dom/cjs/react-router-dom.min";
import { ToastContainer } from "react-toastify";
import LeftSidebar from "../LeftSidebar";
import TopHeader from "../TopHeader";
import { IMAGE_URL } from "../../../constants";
import { thirdparty } from "../../..";
import Modal from "../DeleteConfirmModalPopup";

const JobCircular_create = () => {
    const [fatchdata, setFatchdata] = useState([]);
    const [modalDeleteConfirm, setModalDeleteConfirm] = useState(false);
    const [id, setId] = useState(null);

    const openModalDeleteConfirm = (id) => {
        setModalDeleteConfirm(true);
        setId(id);
        console.log(id, "userid");
    };

    const closeModalDeleteConfirm = () => {
        setModalDeleteConfirm(false);
    };

    const fetchData = async () => {
        try {
            const response = await thirdparty.get("/case_studies");

            if (response.status === 200) {
                setFatchdata(response.data);
            }
        } catch (error) {
            console.error("Error fetching data:", error.message);
        }
    };

    const handleDelete = async () => {
        try {
            const response = await thirdparty.delete(`/case_studies/${id}`);

            if (response.status === 200) {
                console.log(`Item with ID ${id} deleted successfully.`);
                fetchData(); // Fetch updated data after deletion
            }
        } catch (error) {
            console.error(`Error deleting item with ID ${id}:`, error.message);
        } finally {
            closeModalDeleteConfirm();
        }
    };

    useEffect(() => {
        fetchData(); // Initial data fetch
    }, []);

    return (
        <div className="fixed-left">
            <div id="wrapper">
                <Route component={LeftSidebar} />
                <div className="content-page">
                    <div className="content">
                        <Route component={TopHeader} />
                        <div className="row page-content-wrapper g-0 g-3">
                            <div className="col-sm-7"></div>
                            <div className="col-sm-3 text-right"></div>
                            <div className="col-sm-12 mb-4  d-flex justify-content-between align-items-center ">
                                <h5>Case Studies</h5>
                                <a
                                    href="/admin/case_studies_create"
                                    className="btn btn-sm waves-effect waves-light"
                                >
                                    Add Case Studies
                                </a>
                            </div>
                            {fatchdata.length > 0 ? (
                                fatchdata.map((item) => (
                                    <div className="col-md-2" key={item.id}>
                                        <div className="card">
                                            <img
                                                className="card-img-top "
                                                src={IMAGE_URL + "/" + item.featured_image}
                                                alt="Card image cap"
                                                style={{ height: "100%", maxHeight: "150px" }}
                                            />
                                            <div className="card-body">
                                                <p>{item.title}</p>
                                                {/* <h5 className="card-title">{item.name}</h5>
                        <p className="card-text">{item.designation}</p>
                        <p className="card-text">{item.company}</p> */}
                                                <h5
                                                    className="mt-2"
                                                    style={{
                                                        display: "flex",
                                                        alignItems: "flex-end",
                                                        columnGap: "10px",
                                                        rowGap: "10px",
                                                        justifyContent: "flex-end",
                                                    }}
                                                >
                                                    <a
                                                        href={"/admin/case_studies_update/" + item.id}
                                                        item_id={item.id}
                                                    >
                                                        <i className="fa fa-pencil-square "></i>
                                                    </a>
                                                    <a
                                                        href={"/pages/case-study/" + item.id}
                                                        target="_blank"
                                                    >
                                                        <i className="fa fa-eye"></i>
                                                    </a>
                                                    <a onClick={() => openModalDeleteConfirm(item.id)}>
                                                        <i className="fa fa-trash"></i>
                                                    </a>
                                                </h5>
                                            </div>
                                        </div>
                                        <div>
                                            <Modal
                                                show={modalDeleteConfirm}
                                                handleClose={closeModalDeleteConfirm}
                                            >
                                                <div className="custom_reviews_popup">
                                                    <h2 className="text-center">
                                                        Are you sure you want to delete this item?
                                                    </h2>
                                                    <form className="pop-form" id="edit_education">
                                                        <div className="form-group row">
                                                            <div className="col-sm-3 text-center"></div>
                                                            <div className="col-sm-6 text-center">
                                                                <button
                                                                    type="button"
                                                                    className="blue_btn_box add_staff_btn mt-5 mr-2"
                                                                    onClick={closeModalDeleteConfirm}
                                                                >
                                                                    No
                                                                </button>
                                                                <button
                                                                    type="button"
                                                                    className="blue_btn_box add_staff_btn mt-5"
                                                                    onClick={() => {
                                                                        // Add your logic for handling delete here
                                                                        // e.g., this.modalDeletePublication(this.state.publications_id)
                                                                        console.log("Deleting...");
                                                                        // ModalDeleteConfirm(item.id);
                                                                        handleDelete();
                                                                    }}
                                                                >
                                                                    Yes
                                                                </button>
                                                            </div>
                                                            <div className="col-sm-3 text-center"></div>
                                                        </div>
                                                    </form>
                                                </div>
                                            </Modal>
                                        </div>
                                    </div>
                                ))
                            ) : (
                                <div>No data found</div>
                            )}
                        </div>
                    </div>
                </div>
            </div>
            <ToastContainer autoClose={5000} />
        </div>
    );
};

export default JobCircular_create;



// WEBPACK FOOTER //
// ./src/component/admin/job/JobCircular_create.js